import { Injectable } from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import { AvailableNetworks, networkData } from 'src/assets/networkConfig';
import { Web3Service } from './web3.service';


  export interface IStore {
    network:string
  }

  @Injectable({
    providedIn: 'root',
  })
export class StoreService {
    network$: Observable<AvailableNetworks>;
    private _network$: BehaviorSubject<AvailableNetworks>;
    routerInstance$: Observable<AvailableNetworks>;
    private _routerInstance$: BehaviorSubject<AvailableNetworks>;
    tokenInstance$: Observable<AvailableNetworks>;
    private _tokenInstance$: BehaviorSubject<AvailableNetworks>;
    factoryInstance$: Observable<AvailableNetworks>;
    private _factoryInstance$: BehaviorSubject<AvailableNetworks>;
    networkDiff$: Observable<any> ;
    private _networkDiff$ : BehaviorSubject<any>;
    public constructor (  private web3Service: Web3Service) {
        const initialNetwork = localStorage.getItem('network') || AvailableNetworks.polygon as any
        this._network$ = new BehaviorSubject(initialNetwork);
        this.network$ = this._network$.asObservable();


        this._networkDiff$ = new BehaviorSubject(false);

        this.networkDiff$ = this._networkDiff$.asObservable();
         console.log("contructor called");

        const initialRouterInstance = web3Service.artifactsToRouterContract(initialNetwork)
        this._routerInstance$ = new BehaviorSubject(initialRouterInstance);
        this.routerInstance$ = this._routerInstance$.asObservable();

        const initialTokenInstance = web3Service.artifactsToIERCContract(initialNetwork)
        this._tokenInstance$ = new BehaviorSubject(initialTokenInstance);
        this.tokenInstance$ = this._tokenInstance$.asObservable();

        const initialFactoryInstance = web3Service.artifactsToFactoryContract(initialNetwork)
        this._factoryInstance$ = new BehaviorSubject(initialFactoryInstance);
        this.factoryInstance$ = this._factoryInstance$.asObservable();
        this.getnetworkDiff();
        if(window.ethereum){
        // only for metamask
          window.ethereum.on('chainChanged',()=>{
            this.getnetworkDiff(this.web3Service)
          } )
        }else{
          web3Service.provider.on('chainChanged',()=>{
            this.getnetworkDiff(this.web3Service)
          })
        }


    }

    get network (): string {
        return this._network$.getValue();
    }


    async   setnetwork (nextnetwork: AvailableNetworks): Promise<void> {
        localStorage.setItem('network',nextnetwork)
        this._network$.next(nextnetwork);

        // update router instance

        console.log("waiting");
        if(window.ethereum){
            this.web3Service.bootstrapWeb3();
        }
        else{
            this.web3Service.connectWallet()
        }
        const newRouterInstance =   this.web3Service.artifactsToRouterContract(nextnetwork)
        this._routerInstance$.next(newRouterInstance)

        const newTokenInstance =   this.web3Service.artifactsToIERCContract(nextnetwork)
        this._tokenInstance$.next(newTokenInstance)

        const newFactoryInstance =   this.web3Service.artifactsToFactoryContract(nextnetwork)
        this._factoryInstance$.next(newFactoryInstance)

        let networkVersion = this.web3Service.getProvider().networkVersion;
        console.log('currentNetwork',this._networkDiff$.value)

          this._networkDiff$.next(!this._networkDiff$.value);

        console.log('newRouterInstance',newRouterInstance);
        console.log('new factory instance',newFactoryInstance);



    }

    public async getnetworkDiff(web3Service=this.web3Service)  {
      console.log("reached afer listening");
      console.log("web3service",this.web3Service.web3);
      if(web3Service.web3){
        console.log("entered inside if of web3");

      let networkVersion = await web3Service.web3.eth.getChainId();
      console.log(networkVersion,this._network$.getValue(),"network values");
      if(networkVersion ==  parseInt(networkData[this._network$.getValue()].chainId,16)){
        this._networkDiff$.next(false);
        console.log("updated boolean",  this._networkDiff$.getValue());

      } else {
        this._networkDiff$.next(true);
        console.log('current netorwok value', this._networkDiff$.getValue())
        console.log("entered inside else");

      }
    }
    }

}
